import { apiClient } from './api';
import type { Server, CreateServerRequest, UpdateServerRequest } from '../types/server';

export const serverService = {
  getAll: async (tenantId?: string): Promise<Server[]> => {
    const params = tenantId ? { tenantId } : {};
    const response = await apiClient.get<Server[]>('/servers', { params });
    return response.data;
  },

  getById: async (id: string): Promise<Server> => {
    const response = await apiClient.get<Server>(`/servers/${id}`);
    return response.data;
  },

  create: async (data: CreateServerRequest): Promise<string> => {
    const response = await apiClient.post<string>('/servers', data);
    return response.data;
  },

  update: async (data: UpdateServerRequest): Promise<void> => {
    await apiClient.put(`/servers/${data.id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/servers/${id}`);
  },
};












